import { render } from "./AdminConfiguracionPermisos.vue?vue&type=template&id=0fd211b8&scoped=true"
import script from "./AdminConfiguracionPermisos.vue?vue&type=script&lang=js"
export * from "./AdminConfiguracionPermisos.vue?vue&type=script&lang=js"

import "./AdminConfiguracionPermisos.vue?vue&type=style&index=0&id=0fd211b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd211b8"]])

export default __exports__